export * from "ce/pages/AdminSettings/Branding/UpgradeBanner";
import { default as CE_UpgradeBanner } from "ce/pages/AdminSettings/Branding/UpgradeBanner";
export default CE_UpgradeBanner;
